const anchorLinks = [].slice.call(
  document.querySelectorAll(".story__content a[href^='#']")
)
const byline = document.querySelector('[data-byline]')
const bylineHeight = byline.offsetHeight

anchorLinks.forEach(function(jumpTo) {
  jumpTo.addEventListener('click', function(e) {
    e.preventDefault()

    let destination = this.href.split('#')[1]
    let destinationAnchor =
      document.getElementById(destination) ||
      document.getElementByName(destination)
    let windowOffset = destinationAnchor.offsetTop - (bylineHeight + 27)

    window.scrollTo(0, windowOffset)
  })
})
